var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75C10.3683 3.75 8.77325 4.23385 7.41655 5.14038C6.05984 6.0469 5.00242 7.33537 4.378 8.84286C3.75357 10.3504 3.5902 12.0092 3.90853 13.6095C4.22685 15.2098 5.01259 16.6798 6.16637 17.8336C7.32016 18.9874 8.79016 19.7731 10.3905 20.0915C11.9909 20.4098 13.6496 20.2464 15.1571 19.622C16.6646 18.9976 17.9531 17.9402 18.8596 16.5835C19.7661 15.2267 20.25 13.6317 20.25 12C20.2477 9.81267 19.3778 7.71559 17.8311 6.16892C16.2844 4.62225 14.1873 3.75231 12 3.75ZM15.6221 10.5451L11.1798 14.9874C11.1208 15.0465 11.0508 15.0933 10.9738 15.1252C10.8967 15.1571 10.8142 15.1736 10.7308 15.1736C10.6474 15.1736 10.5648 15.1571 10.4878 15.1252C10.4107 15.0933 10.3407 15.0465 10.2818 14.9874L8.37793 13.0836C8.25886 12.9645 8.19196 12.803 8.19196 12.6346C8.19196 12.4662 8.25886 12.3047 8.37793 12.1856C8.49701 12.0665 8.65852 11.9996 8.82693 11.9996C8.99533 11.9996 9.15684 12.0665 9.27592 12.1856L10.7308 13.6413L14.7241 9.64716C14.783 9.5882 14.853 9.54143 14.9301 9.50952C15.0071 9.47761 15.0897 9.46118 15.1731 9.46118C15.2565 9.46118 15.339 9.47761 15.4161 9.50952C15.4931 9.54143 15.5631 9.5882 15.6221 9.64716C15.681 9.70612 15.7278 9.77612 15.7597 9.85316C15.7916 9.9302 15.808 10.0128 15.808 10.0962C15.808 10.1795 15.7916 10.2621 15.7597 10.3391C15.7278 10.4162 15.681 10.4862 15.6221 10.5451Z",
    fill: "#2DC26B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneCompleteIcon);
export default __webpack_public_path__ + "static/media/MilestoneCompleteIcon.31df8444c78cadda12eeded6ec08b57a.svg";
export { ForwardRef as ReactComponent };